import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../../shared';
import { HomeMaterialModule } from '../../home-material/home-material.module';

import { AccountActivityContentComponent } from './account-activity-content/account-activity-content.component';
import { ActivityTabItemComponent } from './activity-tab-item/activity-tab-item.component';
import { ActivityFilterFormComponent } from './activity-filter-form/activity-filter-form.component';
import { CashPaymentComponent } from './cash-payment/cash-payment.component';
import { CashPaymentFiltersComponent } from './cash-payment/cash-payment-filters/cash-payment-filters.component';
import { StatusHistoryModalComponent } from './cash-payment/status-history-modal/status-history-modal.component';
import { ConfirmPaymentModalComponent } from './cash-payment/confirm-payment-modal/confirm-payment-modal.component';
import { PartnerBreakdownComponent } from './cash-payment/partner-breakdown/partner-breakdown.component';
import { PointsActivityComponent } from './points-activity/points-activity.component';
import { TaxableRedemptionComponent } from './taxable-redemption/taxable-redemption.component';
import { UserActivityComponent } from './user-activity/user-activity.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    HomeMaterialModule,
  ],
  declarations: [
    AccountActivityContentComponent,
    ActivityTabItemComponent,
    ActivityFilterFormComponent,
    CashPaymentComponent,
    CashPaymentFiltersComponent,
    StatusHistoryModalComponent,
    ConfirmPaymentModalComponent,
    PartnerBreakdownComponent,
    PointsActivityComponent,
    TaxableRedemptionComponent,
    UserActivityComponent,
  ],
  exports: [
    AccountActivityContentComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class AccountActivityModule {}
